@for(iconName of resolvedIconNames(); track $index){
			<ogs-m3-icon prefix="fal" [icon]="iconName"/> 
	}